module.exports = __webpack_public_path__ + "static/media/home-dig-deeper-with-student-voice.83eef3e2.png";